module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/full/full-layout.component.scss
// module id = ./src/app/layouts/full/full-layout.component.scss
// module chunks = main